import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import CenteredLayout from '../../layout/CenteredLayout';
import MainLayout from '../../layout/MainLayout';
import ResponsiveView from '../../layout/ResponsiveView';
import ProjectAppbar from '../../customComponents/ProjectAppbar';

const BidPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
`;

function BidPage() {
  const navigate = useNavigate();

  // 모바일 레이아웃
  const MobileLayout = (
    <MainLayout currentPage="home">
      <CenteredLayout>
        <ProjectAppbar 
          currentPage="home"
          title="입찰하기"
          showBackButton={true}
          onBack={() => navigate(-1)}
        />
        <BidPageContainer>
          <Title>입찰 페이지</Title>
          <Description>
            입찰 기능이 구현될 예정입니다.
          </Description>
        </BidPageContainer>
      </CenteredLayout>
    </MainLayout>
  );

  // 데스크톱 레이아웃
  const DesktopLayout = (
    <MainLayout currentPage="home">
      <CenteredLayout>
        <ProjectAppbar 
          currentPage="home"
          title="입찰하기"
          showBackButton={true}
          onBack={() => navigate(-1)}
        />
        <BidPageContainer>
          <Title>입찰 페이지</Title>
          <Description>
            입찰 기능이 구현될 예정입니다.
          </Description>
        </BidPageContainer>
      </CenteredLayout>
    </MainLayout>
  );

  return (
    <ResponsiveView
      mobileView={MobileLayout}
      desktopView={DesktopLayout}
    />
  );
}

export default BidPage;
